<!--
 * @Author: wuyingxin
 * @Date: 2022-12-27 16:04:35
 * @LastEditors: wuyingxin
 * @LastEditTime: 2023-01-03 15:35:44
 * @Description: file content
-->
<template>
  <!-- 离场 -->
  <div class="detail">
    <ax-panel :noTitle="true">
      <van-cell title="申请人姓名" :value="data.header.emplid_description"></van-cell>
      <van-cell title="域账号" :value="data.header.qh_domain_id"></van-cell>
      <van-cell title="职务名称" :value="data.header.qh_external_posn"></van-cell>
      <van-cell title="联系方式" :value="data.header.emplid_phone"></van-cell>
      <van-cell title="所属部门" :value="data.header.deptid_description"></van-cell>
      <van-cell title="离场类型" :value="data.header.action_description"></van-cell>
      <van-cell title="离场原因" :value="data.header.qh_ter_act_reason_description"></van-cell>
      <van-cell title="预计离场日期" :value="data.header.termination_dt"></van-cell>
      <van-cell title="资产交接" :value="data.header.qh_asset_handover_description"></van-cell>
    </ax-panel>
  </div>
</template>

<script>
import moment from 'moment'
import request from '@/utils/request'
import watermark from '../../utils/warterMark'
export default {
  props: ['data', 'pageObj', 'comments'],
  data () {
    return {
      action: true,
      leaveData: {
      },
    }
  },
  watch: {
    data() {
      // 水印
      this.$nextTick(() => {
        const name = this.data.current_user;
        const now = new Date();
        const date = `${now.getFullYear()}/${
          now.getMonth() + 1
        }/${now.getDate()} ${now.getHours()}:${
          now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes()
        }`;
        watermark.set(date + name);
      });
    }
  },
  methods: {
    // 获取相同节点数
    getSameNodeTime (nodes, id) {
      let num = 0
      nodes.forEach((item) => {
        if (item.actual[0] === id) {
          num++
        }
      })
      return num
    },
    // 父组件通过ref获取子组件的leaveData
    returnLeaveData () {
      // this.$emit('getLeaveData', this.leaveData, this.action)
    },
    formatDate (date) {
      return moment(date).format('YYYY/MM/DD')
    },
  }
};
</script>
<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}
.van-cell {
  border-bottom: 1px solid $border-color;
}
.van-cell__right-icon {
  // margin-left: -2.8rem;
  // float: right;
  position: absolute;
  right: 0.1rem;
}
.van-cell .van-cell__title {
  width: 4rem;
  // color:#000
}
.w100 .van-cell__title {
  width: 8rem;
}
.van-collapse-item__wrapper .van-collapse-item__content {
  color: rgba(0, 0, 0, 0.9);
}
</style>